<template>
  <div class="unit">
    <div class="unit-text">
      <h1 id="artist">{{ this.artist.name }}</h1>
     

    <transition name="slide-up" mode="out-in">
         <h3 id="followers" v-if="revealed">{{ followerCount }}</h3>
      <div class="controls" v-else-if="!revealed">
        <button @click.prevent="reveal('hi')">Higher ▲</button>
        <button @click.prevent="reveal('lo')">Lower ▼</button>
      </div>
    </transition>
    </div>

    <img :src="this.artist.image" id="the-img" style="z-index: 40" />
  </div>
</template>

<script>
export default {
  props: {
    // artist: String,
    // followers: String,
    // image: String,
    // showFollowers: Boolean,
    // showControls: Boolean,
    // test:Object,

    artist: Object,
    isRevealed: Boolean,
  },

  computed: {
    followerCount() {

      const formattedNum = String(this.displayNum).replace(/(.)(?=(\d{3})+$)/g,'$1,'); 
      return "has " + formattedNum + " followers";
    },
  },
  methods: {
    reveal(selection) {
     
      this.revealed = true;
      this.$emit('revealed',{id: this.artist.id, selection: selection }); 
    },


     animateNum(currentNum, target){

    return Math.max(currentNum + Math.floor((target-currentNum)*0.19), currentNum + 1); 

  }

  },

  data() {
    return {
      revealed: false,
      myValue:0, 
      displayNum:0 
    };
  },

  created() {
    this.displayNum = Math.floor(this.artist.followers*0.1); 
    if (this.isRevealed) {
      this.revealed = true;
      this.displayNum=this.artist.followers; 
    }
  },

 mounted() {
    this.myValue = 0;
    setInterval(() => {
      
      this.revealed && this.displayNum<this.artist.followers ? this.displayNum= this.animateNum(this.displayNum, this.artist.followers): null; 
    }, 16);
  },


 

};
</script>

<style scoped>



#the-img{
 
 /* height: 550px; */
  height: min(550px, 75vmin);
 
overflow: hidden;

object-fit:cover;

width: min(550px, 75vmin);


}



.unit {
  position: relative;
  margin: 2em;
  margin-bottom: 0;
  transition: all 0.8s ease-out;
  /* width: 640px;  */
  padding-inline: 2.5em;
  background-color: rgba(47, 79, 79, 0);
  /* background-color:#1DB954; */

  
}

@media (max-aspect-ratio: 5/6) {

#artist{
  font-size: 6.5vw;
  margin:0; 
}
#followers{
  font-size:0.8em;
}

.unit{
  margin: 1em;
  padding:0; 
  width: min(550px, 80vmin);
 
  overflow: hidden;
}



}

.unit-text {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, 0);

  text-align: center;

  color: white;
  width: 100%;
  text-shadow: 3px 3px 10px black;
}
.unit a {
  position: absolute;
  top: 90%;
  left: 80%;
}




.controls button {
  background-color: rgba(0, 0, 0, 0.1);
  color: white;
  border: 2px solid #ffffff;
  border-radius: 20em;
  border-bottom-color: white;
  padding-inline: 2em;
  padding-block: 0.7em;
  margin-inline: 1em;
  transition: all 0.5s ease;
  backdrop-filter: blur(10px);
  font-weight: 600;
}

.controls button:hover {
  background-color: white;
  color: black;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
  transform:translateY(0); 

}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
  
}

</style>